import React from "react";
import { BottomNavigation, BottomNavigationAction, Box, Typography } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import YoutubeIcon from "@mui/icons-material/YouTube";

const Footer = () => {
  return (
    <Box
      sx={{
        mt: "auto",
        backgroundColor: "primary.main",
        color: "white",
        py: 2,
      }}
    >
      {/* Bottom Navigation with social links */}
      <BottomNavigation
        sx={{ backgroundColor: "transparent" }}
        showLabels
      >
        <BottomNavigationAction
          label="Facebook"
          icon={<FacebookIcon />}
          href="https://facebook.com/PraiseofRevivalchurch"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "white" }}
        />
        <BottomNavigationAction
          label="Instagram"
          icon={<InstagramIcon />}
          href="https://instagram.com/praiserevivalchurch"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "white" }}
        />
        <BottomNavigationAction
          label="Youtube"
          icon={<YoutubeIcon />}
          href="https://www.youtube.com/@praiserevivalchurch9814"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "white" }}
        />
      <BottomNavigationAction
          label="Email"
          icon={<MailOutlineIcon />}
          href="mailto:info@praiserevivalchurch.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "white" }}
        />
      </BottomNavigation>

      {/* Footer text */}
      <Typography
        variant="body2"
        align="center"
        sx={{ color: "white", mt: 1 }}
      >
        &copy; 2024 Praise Revival Church. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
